import styles from "./General.module.css";
import logo from "../../assets/image/logo.png";

export default function SemParametro() {
    return (
        <section className={styles.General}>
            <img src={logo} alt="Logo do ISM" />

            <span> Estão faltando os dois parâmetros necessários para o redirecionamento: o código da campanha e o ID do influenciador. </span>
        </section>
    )
}